import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const InviteSubmitPopup = loadAsyncComponent(() => import('./View'), 'popup');
